<template>
  <div class="resetPassword">
    <!-- 表单部分 -->
    <van-cell-group class="cell_group">
      <van-form validate-first @failed="onFailed" @submit="onSubmit">
        <!-- 通过 pattern 进行正则校验 -->
        <div class="login_label">重置密码</div>
        <van-field
          v-model="password"
          name="password"
          placeholder="请输入新密码"
          scroll-to-error
          clearable
          type="password"
          :rules="[
            {
              validator: checkPassword,
              message: '密码至少要6位',
              required: true,
            },
          ]"
        />
        <van-field
          v-model="rePassword"
          name="rePassword"
          placeholder="再一次输入新密码"
          scroll-to-error
          clearable
          type="password"
          :rules="[
            {
              validator: checkRepassword,
              message: '两次输入密码不一致',
              required: true,
            },
          ]"
        />

        <!-- 登陆按钮 -->
        <div class="btn-wrap" style="margin-top: 16px">
          <van-button round block type="info" class="btn" native-type="submit"
            >完成</van-button
          >
        </div>
      </van-form>
    </van-cell-group>
  </div>
</template>

<script>
import "../../assets/css/resetPassword.less";
import { resetPassword } from "@/api/user";
import { Toast } from "vant";
// import axios from "axios";

export default {
  name: "ResetPassword",
  data() {
    return {
      password: "",
      rePassword: "",
    };
  },
  created() {
    this.loadComments();
  },
  methods: {
    loadComments() {},
    checkPassword() {
      return this.password.length >= 6 && this.password.length <= 20;
    },
    checkRepassword() {
      return this.password == this.rePassword;
    },
    onFailed(errorInfo) {
      console.log("failed", errorInfo);
    },
    //表单提交
    onSubmit(values) {
      let mobile = sessionStorage.getItem("forgetMobile");
      let code = sessionStorage.getItem("forgetCode");
      let data = {
        code: code,
        mobile: mobile,
        password: values.password,
        passwordRepeat: values.rePassword,
      };
      resetPassword(data).then((resp) => {
        if (resp.data.code == "0000") {
          this.$router.push("/login");
          Toast("密码已重置，请重新登录！");
        } else {
          Toast(resp.data.msg);
        }
      });
    },
  },
};
</script>


